import React from 'react';
import { Button } from 'reactstrap';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';

import ModalButton from './ModalButton';
import useTenant from './hooks/useTenant';

function ShareInquiryModalContent ({ inquiry, toggleModal }) {
  const tenant = useTenant();
  const shareUrl = inquiry.shareKey && `${window.location.origin}/${tenant.id}/sharedInquiries/${inquiry.shareKey}`;

  const onGenerate = async () => {
    await inquiry.ref.update({ shareKey: uuid() });
    toast.success('共有URLを発行しました');
  };

  const onCopy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    toast.success('共有URLをコピーしました');
  };

  const onRevoke = async () => {
    if (!window.confirm('共有URLを無効にしますか？')) return;
    await inquiry.ref.update({ shareKey: null });
    toast.success('共有URLを無効にしました');
  };

  const onTogglePersonalInfo = async () => {
    await inquiry.ref.update({ shareShowsPersonalInfo: !inquiry.shareShowsPersonalInfo });
  };

  return (
    <div>
      {shareUrl ? (
        <div>
          <div className="mb-3">
            <label className="font-weight-bold">共有URL</label>
            <div className="d-flex align-items-center gap-2">
              <input type="text" className="form-control form-control-sm" value={shareUrl} readOnly />
              <Button color="primary" size="sm" className="text-nowrap" onClick={onCopy}>
                <span className="fas fa-copy mr-1" />コピー
              </Button>
            </div>
          </div>
          <div className="mb-3">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="shareShowsPersonalInfo"
                checked={!!inquiry.shareShowsPersonalInfo}
                onChange={onTogglePersonalInfo}
              />
              <label className="custom-control-label" htmlFor="shareShowsPersonalInfo">
                個人情報を含める
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <Button color="danger" size="sm" outline onClick={onRevoke}>
              無効化
            </Button>
            <Button className="cancel" onClick={toggleModal.bind(null, false)}>閉じる</Button>
          </div>
        </div>
      ) : (
        <div>
          <div className="mb-3 text-muted">共有URLはまだ発行されていません。</div>
          <div className="d-flex justify-content-between">
            <Button color="primary" onClick={onGenerate}>
              発行
            </Button>
            <Button className="cancel" onClick={toggleModal.bind(null, false)}>閉じる</Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function ShareInquiryButton ({ inquiry }) {
  return (
    <ModalButton
      title="共有URL"
      content={({ toggleModal }) => <ShareInquiryModalContent inquiry={inquiry} toggleModal={toggleModal} />}
      hidesFooter
    >
      <span className="fas fa-share-alt mr-1" />共有URL
    </ModalButton>
  );
}
